import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/resolve',
    name: 'resolve',
    component: () => import('../views/ResolveView.vue')
  },
  {
    path: '/shop',
    name: 'shop',
    component: () => import('../views/ShopView.vue')
  },
  {
    path: '/AIoT',
    name: 'AIoT',
    component: () => import('../views/AIoTView.vue')
  },
  {
    path: '/application',
    name: 'application',
    component: () => import('../views/ApplicationView.vue')
  },
  {
    path: '/service',
    name: 'service',
    component: () => import('../views/ServiceView.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue')
  },
  {
    path: '/Connect',
    name: 'Connect',
    component: () => import('../views/ConnectView.vue')
  },
  {
    path: '/Article',
    name: 'Article',
    component: () => import('../views/ArticleView.vue')
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
